/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ScaleQuizOnPaper60Min = ({ rowData }) => {
  const classes = useStyles();
  return (
    <div className={classes.gradeDetails}>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Vocabulaire médical :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.vocabulary || '0'}
          /60
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Compréhension écrite :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.readingcomprehension || '0'}
          /20
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.totalGrade}>
          Total :
        </Typography>
        <Typography className={classes.totalGrade}>
          {parseFloat(rowData?.grade?.vocabulary || 0)
          + parseFloat(rowData?.grade?.readingcomprehension || 0)}
          /80
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.totalGrade}>
          Note :
        </Typography>
        <Typography className={classes.totalGrade}>
          {Math.round(((parseFloat(rowData?.grade?.vocabulary || 0)
          + parseFloat(rowData?.grade?.readingcomprehension || 0)) / 80) * 20)}
          /20
        </Typography>
      </div>
    </div>
  );
};

export default ScaleQuizOnPaper60Min;
